import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { MatDialog, MatPaginator, MatSort, MatSelect } from '@angular/material';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { CommonService } from '../../core/service/common-service/common.service';
import { FilterPipePipe } from '../../pipes/filter-pipe.pipe';
import { ListCustData } from './listCustData';

@Component({
  selector: 'app-soft-offerings',
  templateUrl: './soft-offerings.component.html',
  styleUrls: ['./soft-offerings.component.scss'],
  providers: [FilterPipePipe]
})
export class SoftOfferingsComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  customerData: any;
  currentDate: string;
  spinner: boolean;
  userId: string;
  userRoles: any;
  selectedCallTypeValues: string[] = [];
  selectedCallStateValues: string[] = [];
  uniqueCallType = new Set<string>();
  uniqueCallState = new Set<string>();
  pageSize: number;
  filterMap = new Map();
  dataSource: any;
  filteredDataSource: any;
  callsToBeMade: number = 0;
  callsMade: number = 0;
  callToggleStatus: boolean = true;
  selection: any;
  callFlag: any;
  customersToBeCalled: string;
  callsMade1: string;
  userRoleId: string;
  listFlag: string;
  displayedColumns: string[] = [
    'customerName',
    'callType',
    'callStatus',
    'lastCallTime',
    'creInput',
    'followUpTime',
    'remarks'
  ];

  constructor(private router: Router,private toastr: ToastrService,private commonService: CommonService,
    private datePipe: DatePipe, private filterPipePipe: FilterPipePipe) { }

  ngOnInit() {

    if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == undefined) {
      this.router.navigate(['login']);
    }
    this.customerData = JSON.parse(localStorage.getItem('customerData'));
    this.userId = localStorage.getItem('userId');
    this.currentDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.userRoles = localStorage.getItem('userRoles');

    this.userRoleId = JSON.parse(localStorage.getItem("userInfo"))[0].roleId;
    if (localStorage.getItem('selectedCallTypeValues') != null || localStorage.getItem('selectedCallTypeValues') != undefined) {
      let selectedCallTypeValues = JSON.parse(localStorage.getItem('selectedCallTypeValues'));
      this.selectedCallTypeValues = selectedCallTypeValues;
    }

    if (localStorage.getItem('selectedCallStateValues') != null || localStorage.getItem('selectedCallStateValues') != undefined) {
      let selectedCallStateValues = JSON.parse(localStorage.getItem('selectedCallStateValues'));
      this.selectedCallStateValues = selectedCallStateValues;
    }

    if (localStorage.getItem('callListPageSize') != null || localStorage.getItem('callListPageSize') != undefined) {
      let pagesize = Number(localStorage.getItem('callListPageSize'));
      // this.pageSize = (pagesize && pagesize != NaN) ? pagesize : 50;
    } else {
      this.pageSize = 50;
    }

    // if ((localStorage.getItem('workshops') == null || localStorage.getItem('workshops') == undefined) && this.userRoles !='Call Center Agent') {
    //   this.getWorkshopDetails();
    // }
    //this.getCreStats();
    if(this.userRoleId == '2') {
      this.listFlag = 'Z';
      setTimeout(() => this.amcpairCallList('Z', this.userId, this.userRoleId), 1000);
    } else {
      this.listFlag = 'Y';
      setTimeout(() => this.amcpairCallList('Y', this.userId, this.userRoleId), 1000);
    }

  }

  /**
  * Name: setPageData
  * purpose: To set pagesize for table
  */
 setPageData(event) {
  let size = event.pageSize.toString();
  localStorage.setItem('callListPageSize', size);
}

/**
  * Name: getWorkshopDetails
  * purpose: To get CRE assigned workshop details
  */
 getWorkshopDetails() {
  this.spinner = true;
  this.commonService.getWorkshopDetails(this.userId)
    .subscribe(res => {
      if (res['responseCode'] == 0) {
        this.spinner = false;
        localStorage.setItem('workshops', JSON.stringify(res['responseData']));
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
   * Name: activeButton
   * purpose: To activat apply button
   */
  activeButton(): boolean {
    let flag = false;
    if(this.selectedCallTypeValues != null && this.selectedCallTypeValues.length != 0) {
      flag = true;
    } else if (this.selectedCallStateValues != null && this.selectedCallStateValues.length != 0) {
      flag = true;
   }
    return flag;
  }

  /**
   * Name: applyfilter
   * purpose: To apply filter on call list data
   */
  applyfilter(): void {
    let key = '';
    this.filterMap = new Map();
    this.filteredDataSource = this.dataSource;

    if(this.selectedCallTypeValues != null && this.selectedCallTypeValues.length != 0){
      key = "callType";
      this.filterMap.set(key, this.selectedCallTypeValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if(this.selectedCallStateValues != null && this.selectedCallStateValues.length != 0){
      key = "callStatus";
      this.filterMap.set(key, this.selectedCallStateValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    //this.filterMap.set(this.selectedCol, this.selectedColValues);
    //this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.dataSource.filteredData, this.filterMap));
    this.callsToBeMade = this.filteredDataSource.filteredData.length;
    this.sort.direction = '';
    this.filteredDataSource.sort = this.sort;
    this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
    this.filteredDataSource.paginator = this.paginator;
    localStorage.setItem('selectedCallTypeValues',JSON.stringify(this.selectedCallTypeValues));
    localStorage.setItem('selectedCallStateValues',JSON.stringify(this.selectedCallStateValues));
    //localStorage.setItem('selectedCol', this.selectedCol);
    //localStorage.setItem('selectedColValues', JSON.stringify(this.selectedColValues));
  }

  /**
   * Name: searchfilter
   * purpose: To apply filter on call list data
   */
  searchfilter(filterValue: string): void {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.filteredDataSource.filter = filterValue;
  }

  /**
    * Name: amcpairCallList
    * purpose: To get calllist details
    * @param {string} flag - type of call
    * @param {string} creId - User Id
    * @param {any} userRoleId - User Id
    */
   amcpairCallList(flag: string, creId: string, userRoleId: string): void {
    this.spinner = true;
    this.selection = new SelectionModel<ListCustData>(true, []);

    this.commonService.amccustomercallList(flag, creId, userRoleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          if (flag == 'Y' || flag == 'Z') {
            this.callFlag = flag;
            this.callToggleStatus = true;
          } else {
            this.callFlag = flag;
            this.callToggleStatus = false;
          }

          if (res['responseData'].length) {
            res['responseData'].forEach(data => {
              // if ((data.accountType).toLowerCase() == "lost") {
              //   let changeName = data.customerName.split(" - L")[0];
              //   data.customerName = changeName;
              // }
              let inboundCustomer = data.customerName.includes("- I");
              let stringPosition = data.customerName.length;
              let lostString = data.customerName[stringPosition - 3] + data.customerName[stringPosition - 2] + data.customerName[stringPosition - 1]
              if (inboundCustomer && lostString == "- I") {
                let changeName = data.customerName.split(" - I")[0];
                data.customerName = changeName;
                data.isInboundCall = true;
              }
            });
          }
          this.callsToBeMade = res['responseData'].length;
          //init data table and shorting
          this.dataSource = new MatTableDataSource<ListCustData>(res['responseData']);
          //this.sort.direction = '';
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = (data, header) => data[header];
          this.dataSource.paginator = this.paginator;
          this.filterData();
          if ((this.selectedCallTypeValues != null && this.selectedCallTypeValues.length == 0)
          && (this.selectedCallStateValues != null && this.selectedCallStateValues.length == 0)) {
            //init filtered table and shorting
            this.filteredDataSource = new MatTableDataSource<ListCustData>(res['responseData']);
            //this.sort.direction = '';
            this.filteredDataSource.sort = this.sort;
            this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
            this.filteredDataSource.paginator = this.paginator;
          }
          this.spinner = false;
          this.callsMadeCalculate(res['responseData']);
          this.callListinfo();
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
          this.callToggleStatus = true;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        this.callToggleStatus = true;
      });
  }

  /**
    * Name: callsMadeCalculate
    * purpose: To get call made count
    * @param {Array} callsToBeMade - list of calls
    */
   callsMadeCalculate(callsToBeMade: any) {
    this.callsMade = 0;
    callsToBeMade.forEach(element => {
      let currentDate = "" + this.datePipe.transform(new Date(), "yyyy-MM-dd");
      // let reqDate = this.datePipe.transform((element.lastCallTime), "yyyy-MM-dd");
      // if (currentDate == reqDate) {
      //   this.callsMade++;
      // }
    });
  }

  /**
    * Name: callListinfo
    * purpose: To get call count info
    */
   callListinfo(): void {
    this.spinner = true;
    this.commonService.amcCallListinfo(this.userId, this.userRoleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.customersToBeCalled = res['responseData'].callToBeMade;
          this.callsMade1 = res['responseData'].callMade;
          this.spinner = false;
        } else {
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        //...
      });
  }

  /**
    * Name: selectCustomer
    * purpose: To select customer for details
    * @param {Object} row - selected customer details
    */
   selectCustomer(row: ListCustData): void {
    localStorage.setItem('customerId', row.customerId);
    //localStorage.setItem('custNotification', row.serviceType + ", " + row.callStatusDesc);
    //localStorage.setItem("vin", row.vin);
    //localStorage.setItem("dealerCode", row.dealerCode);
    localStorage.setItem("customerData", JSON.stringify(row));
    this.router.navigate(['soft-customer360']);
  }

   /**
   * Name: filterData
   * purpose: To filter call list data
   */
  filterData(): void {
    this.dataSource.filteredData.forEach(element => {
      this.uniqueCallType.add(element.callType);
      this.uniqueCallState.add(element.callStatus);
    });

    if ((this.selectedCallTypeValues != null && this.selectedCallTypeValues.length != 0)
    || (this.selectedCallStateValues != null && this.selectedCallStateValues.length != 0)) {
      //this.filterTriggered(null);
      this.applyfilter();
    }
  }

   /**
   * Name: clearFilter
   * purpose: To clear filter
   */
  clearFilter(listChange:boolean, listType: any): void {
    if(listType != 'X') {
      if(this.userRoleId == '2') {
        listType = 'Z';
      } else {
        listType = 'Y'
      }
    }
    if(listChange) {
      this.dataSource = [];
      this.filteredDataSource = [];
      this.amcpairCallList(listType, this.userId, this.userRoleId);
    } else {
      this.filterMap.clear();
      this.selectedCallTypeValues = null;
      this.selectedCallStateValues = null;
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.dataSource.filteredData, this.filterMap));
      this.callsToBeMade = this.filteredDataSource.filteredData.length;
      this.sort.direction = '';
      this.filteredDataSource.sort = this.sort;
      this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
      this.filteredDataSource.paginator = this.paginator;
      localStorage.removeItem('selectedCallTypeValues');
      localStorage.removeItem('selectedCallStateValues');
    }
  }

  /**
   * Name: changeColor
   * purpose: To change followup time color
   */
  changeColor(followUp:any): String {
    let currentTime = this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss ");

    if(followUp != null && followUp != undefined  && followUp != "") {
      let followUpDateTime = this.datePipe.transform(followUp, "yyyy-MM-dd HH:mm:ss");
      if((new Date(currentTime)).getTime() > (new Date(followUpDateTime).getTime())){
        return "red";
      }
    }
  }
}